import React from 'react';
import { withTranslation } from 'react-i18next';
import { Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';

const ImportsFilters = ({ filters, onFiltersChange, t }) => {
  const handleStatusChange = (e) => {
    onFiltersChange({ ...filters, status: e.target.value });
  };

  const handleIdentifierChange = (e) => {
    onFiltersChange({ ...filters, identifier: e.target.value });
  };

  return (
    <div className="imports-filters mb-4">
      <Form>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="status-filter">
                {t('imports.filters.status', 'Status')}
              </Label>
              <Input
                type="select"
                id="status-filter"
                value={filters.status}
                onChange={handleStatusChange}
              >
                <option value="">
                  {t('imports.filters.all-status', 'Todos os status')}
                </option>
                <option value="pending">
                  {t('imports.status.pending', 'Pendente')}
                </option>
                <option value="done">
                  {t('imports.status.done', 'Concluído')}
                </option>
                <option value="error">
                  {t('imports.status.error', 'Erro')}
                </option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="identifier-filter">
                {t('imports.filters.type', 'Tipo')}
              </Label>
              <Input
                type="select"
                id="identifier-filter"
                value={filters.identifier}
                onChange={handleIdentifierChange}
              >
                <option value="">
                  {t('imports.filters.all-types', 'Todos os tipos')}
                </option>
                <option value="import_incentives">
                  {t('imports.types.incentives', 'Incentivos')}
                </option>
                <option value="import_catalog">
                  {t('imports.types.catalog', 'Catálogo')}
                </option>
                <option value="update_customers">
                  {t(
                    'imports.types.update-customers',
                    'Atualização de Clientes'
                  )}
                </option>
                <option value="import_customers">
                  {t(
                    'imports.types.import-customers',
                    'Importação de Clientes'
                  )}
                </option>
                <option value="import_product_strategy">
                  {t('imports.types.product-strategy', 'Estratégia de Produto')}
                </option>
                <option value="deactivate_users">
                  {t('imports.types.deactivate-users', 'Desativar Usuários')}
                </option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default withTranslation()(ImportsFilters);
